import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { DrainageType, DrivewayType, LocationType, WaterType } from '../store/offer';

export type TParam = 'electricity' | 'gas' | 'drainage' | 'water';

const LocationTypeName = {
  [LocationType.Border]: 'по границе участка',
  [LocationType.Location]: 'на участке',
  [LocationType.No]: 'нет',
};

const DrainageTypeName = {
  [DrainageType.Autonomous]: 'Автономная',
  [DrainageType.Central]: 'Центральная',
  [DrainageType.SepticTank]: 'Септик',
  [DrainageType.Storm]: 'Ливневая',
  [DrainageType.TreatmentFacilities]: 'Очистные сооружения',
};

const WaterTypeName = {
  [WaterType.Autonomous]: 'Автономное',
  [WaterType.Central]: 'Центральное',
  [WaterType.PumpingStation]: 'Водонапорная станция',
  [WaterType.WaterIntakeFacility]: 'Водозаборный узел',
  [WaterType.WaterTower]: 'Водонапорная башня',
};

const DrivewayTypeName = {
  [DrivewayType.Asphalt]: 'Асфальтированная дорога',
  [DrivewayType.Ground]: 'Грунтовая дорога',
  [DrivewayType.No]: 'Нет',
};

export function getAvailability(offer: IOfferSchema, param: TParam): string {
  const paramInfo = offer[param];

  if (paramInfo && paramInfo.locationType) {
    if (paramInfo.locationType === LocationType.No) {
      return paramInfo.possibleToConnect ? 'Нет, можно подключить' : '';
    }

    return LocationTypeName[paramInfo.locationType] ? `Есть, ${LocationTypeName[paramInfo.locationType]}` : '';
  }

  return '';
}

export function getElectricityPower(offer: IOfferSchema): string {
  return offer.electricity && offer.electricity.power ? `${numberToPrettyString(offer.electricity.power)} кВт` : '';
}

export function getDrainageType(offer: IOfferSchema): string {
  return offer.drainage && offer.drainage.type && DrainageTypeName[offer.drainage.type]
    ? DrainageTypeName[offer.drainage.type]
    : '';
}

export function getDrainageCapacity(offer: IOfferSchema): string | number {
  return offer.drainage && offer.drainage.capacity ? offer.drainage.capacity : '';
}

export function getWaterType(offer: IOfferSchema): string {
  return offer.water && offer.water.type && WaterTypeName[offer.water.type] ? WaterTypeName[offer.water.type] : '';
}

export function getWaterCapacity(offer: IOfferSchema): string | number {
  return offer.water && offer.water.capacity ? offer.water.capacity : '';
}

export function getDrivewayType(offer: IOfferSchema): string {
  return offer.drivewayType && DrivewayTypeName[offer.drivewayType] && offer.drivewayType !== DrivewayTypeName.No
    ? DrivewayTypeName[offer.drivewayType]
    : '';
}
